var React = require('react');

function Line (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 6H108","stroke":"#1564FD","strokeWidth":"2","strokeLinecap":"square","strokeDasharray":"4 4","key":0}),React.createElement("circle",{"cx":"5.5","cy":"5.5","r":"5.5","fill":"#1564FD","key":1}),React.createElement("circle",{"cx":"113.5","cy":"5.5","r":"5.5","fill":"#1564FD","key":2}),React.createElement("circle",{"cx":"5.5","cy":"5.5","r":"2.5","fill":"#FCFCFC","key":3}),React.createElement("circle",{"cx":"113.5","cy":"5.5","r":"2.5","fill":"#FCFCFC","key":4})]);
}

Line.defaultProps = {"width":"119","height":"11","viewBox":"0 0 119 11","fill":"none"};

module.exports = Line;

Line.default = Line;
